const config = {
    development: {
        API_URI: process.env.REACT_APP_API_URI || 'http://localhost:4000/api',
    },
    production: {
        API_URI: 'https://patricians-efc2bedb7e1c.herokuapp.com/api',
    }
};

export default config[process.env.NODE_ENV || 'development'];